import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const OnsenPopupPromosRemoveDialog = makeConfirmActionDialog({
  mutationName: "onsenPopupPromosRemove",
  paramName: "onsenPopupPromoIds",
  action: "Remove Onsen Popup Promo",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Remove",
    };
  },
});
